import { hasAcceptedCookies, isRecentCookieTimestamp } from 'utils/cookies';
import { useFlag } from 'utils/launchdarkly';

export const useHasAcceptedCookies = () => {
  const isCookieVersioningEnabled = useFlag('enable-cookie-versioning');
  if (isCookieVersioningEnabled) {
    return hasAcceptedCookies();
  }
  return isRecentCookieTimestamp();
};
